const settingsWhite = {
    backgroundColor : '#F0F2F8',
    backgroundColor2 : '#FFFFFF',
    cardBackgroundColor: '#FFFFFF',
    inputBackgroundColor: '#F0F2F8',
    card2BackgroundColor: '#FFFFFF',
    card3BackgroundColor: '#F5F4F4',
    card4BackgroundColor : '#F2F2F2',
    footerBackgroundColor: '#3E9FDD',
    footerWave : `url(/assets/img/fond_bleu.png)`,
    textColor : '#3E9FDD',
    textColor2 : '#6D7C84',
    logoUrl : `/assets/icon/logo-ohs.png`,
    textColor3 : '#263238',
    textColor4 : '#C72B5C',
    textColor5 : '#00394C',
    textColor6 : '#C72B5C',
    textColor7 : '#626262',
    textColor8 : '#99B0B8',
    textColor9 : 'rgba(18, 22, 25, 0.55)'   ,
    textColor10 : '#26383E',
    breadcrumbColor1 : '#3E9FDD',
    pinkBackgroundColor : 'rgba(199, 43, 92, 0.04)',
    notifCardBackgroundCor : '#F0EFEF',
    color11: '#3E9FDD',
    color12: '#f1f1f1',
    color13: '#EEEEEE',
    color14: '#263238',
    color15: '#E5F2F7',
    textColor11 : '#3E9FDD',
    iconNotif: 'black',
}

export default settingsWhite;
